import axios from "axios";
import { getStoredAuthToken } from "../utils/authTokenStorage";
import { getBackendBaseUrl } from "../utils/backendUrl";
const backendBaseUrl = getBackendBaseUrl();

const api = axios.create({
	baseURL: backendBaseUrl,
	withCredentials: true,
});

try {
	const storedToken = getStoredAuthToken();
	if (storedToken) {
		api.defaults.headers.Authorization = `Bearer ${storedToken}`;
	}
} catch (err) {
}

export const openApi = axios.create({
	baseURL: backendBaseUrl
});

export default api;
